<template>
  <slider-promo />

  <the-nav />

  <div class="main-wrap">
    <div class="promo-wrap">
      <div class="promo-item">
        <img :src="require('@/assets/images/promo1.webp')" class="promo-image" alt="" />
        <div class="promo-item-content">
          <div class="promo-item-title">Бонус до 1 000 000 ₽ <br />кэшбек до 50%</div>
          <div class="promo-item-text">Воспользуйтесь уникальной многоуровневой системой и достигните ее вершины.</div>
          <router-link :to="{ name: 'levels' }" class="promo-item-btn">Подробнее</router-link>
        </div>
      </div>

      <div class="promo-item">
        <img :src="require('@/assets/images/promo2.webp')" class="promo-image" alt="" />
        <div class="promo-item-content">
          <div class="promo-item-title">Ежедневные<br />турниры</div>
          <div class="promo-item-text">
            Захватывающие турниры, в которых могут испытать свою удачу все участники клуба Миллионъ проходят ежедневно.
          </div>
          <router-link :to="{ name: 'tournaments' }" class="promo-item-btn">Подробнее</router-link>
        </div>
      </div>

      <div class="promo-item">
        <img :src="require('@/assets/images/promo3.webp')" class="promo-image" alt="" />
        <div class="promo-item-content">
          <div class="promo-item-title">Стартовые бонусы<br />на 250% + 30 FS</div>
          <div class="promo-item-text">
            Новичок на Миллионъ ? Тогда воспользуйтесь приветственным бонусом в 250% на первые депозиты и 30 фриспинами.
          </div>
          <router-link :to="{ name: 'bonuses' }" class="promo-item-btn">Подробнее</router-link>
        </div>
      </div>

      <div class="promo-item">
        <img :src="require('@/assets/images/promo4.webp')" class="promo-image" alt="" />
        <div class="promo-item-content">
          <div class="promo-item-title">Впечатляющий <br />джекпот</div>
          <div class="promo-item-text">
            Сорвать джекпот в нашем клубе вполне реально, для этого вам необходимо стать активным игроком.
          </div>
          <router-link :to="{ name: 'jackpots' }" class="promo-item-btn">Подробнее</router-link>
        </div>
      </div>
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import PlayLine from '@/components/PlayLine'
import SliderPromo from '@/components/sliders/SliderPromo'
import TheNav from '@/components/TheNav'
import BonusesLine from '@/components/BonusesLine.vue'

export default {
  name: 'Promo',
  components: { BonusesLine, TheNav, PlayLine, SliderPromo },
}
</script>

<style scoped></style>
